import React from "react";
import map from "lodash/map";
import submit from "submit-form";

import ProgramCard from "../../../parts/cards/program-card";
import CycleCard from "../../../parts/cards/cycle-card";
import Pagination from "../../../parts/pagination";
import DropdownIconsCheck from "../../../parts/inputs/dropdown-icons-check";
import SvgIcon from "../../../parts/SvgIcon";
import { AthleteSelect } from "../../../parts/inputs/athlete-select-new";
import { AthleteLinks } from "../../../parts/athlete-links";
import getAvatarUrl from "../../../utils/get-avatar-url";

const pageSize = 40;

const sortItems = [
  {
    title: "Date Added",
    src: "/img/svg/arrow-to-bottom.svg",
    alt: "createdDate",
    className: "icon-white",
    id: "createdDate",
  },
  {
    title: "A-Z",
    src: "/img/svg/sort-amount-up.svg",
    alt: "name",
    className: "icon-white",
    id: "name",
  },
  {
    title: "Z-A",
    src: "/img/svg/sort-amount-down.svg",
    alt: "nameDescending",
    className: "icon-white",
    id: "nameDescending",
  },
];

class View extends React.Component {
  render() {
    const { locals } = this.context;
    const referAsClients = Boolean(locals.activeUser.referAsClients);
    const athlete = locals.athlete;
    const pathname = locals.pathname;
    const query = locals.query;
    return (
      <main className="athlete-programs">
        <div className="athlete-section-header only-show-mobile">
          <AthleteLinks
            athlete={athlete}
            pathName={pathname}
            classNames={"only-show-mobile"}
            query={query}
          />
          <div className="athlete-select dropdown-athlete">
            <div
              className="avatar"
              style={{
                backgroundImage: `url(${getAvatarUrl(athlete)})`,
              }}
            />
            <AthleteSelect locals={locals} />
          </div>
        </div>
        {/* header for desktop */}
        <header className="force-mobile-hidden">
          <div>
            <DropdownIconsCheck
              items={sortItems}
              action={(sort) => {
                submit(`/actions/refresh`, {
                  method: "GET",
                  body: { sort },
                });
              }}
              title="Sort"
              checkedPath="/img/new-icons/check.svg"
              unCheckedPath="/img/new-icons/uncheck.svg"
            />
            <HeaderAnchorsPrograms referAsClients={referAsClients} />
          </div>
        </header>
        {/* header for mobile */}
        <header className="force-only-show-mobile">
          <div className="header-anchors-programs">
            <HeaderAnchorsPrograms referAsClients={referAsClients} />
          </div>
          <div className="header-legends-programs">
            <DropdownIconsCheck
              items={sortItems}
              action={(sort) => {
                submit(`/actions/refresh`, {
                  method: "GET",
                  body: { sort },
                });
              }}
              title="Sort"
              checkedPath="/img/new-icons/check.svg"
              unCheckedPath="/img/new-icons/uncheck.svg"
            />
          </div>
        </header>

        <section>
          <div className="columns">
            {query["program-view"] === "programs"
              ? map(this.props.cards, (program, cardIndex) => {
                  return (
                    <ProgramCard
                      key={program._id}
                      program={program}
                      cardIndex={cardIndex}
                      athlete={query.athlete}
                    />
                  );
                })
              : map(this.props.cards, (cycle, cardIndex) => {
                  return (
                    <CycleCard
                      key={cycle._id}
                      cycle={cycle}
                      cardIndex={cardIndex}
                    />
                  );
                })}
          </div>
          <Pagination
            total={this.props.total}
            pageSize={this.props.pageSize || pageSize}
          />
        </section>
      </main>
    );
  }
}

export default View;

const HeaderAnchorsPrograms = ({ referAsClients }) => {
  return (
    <>
      <a
        role="button"
        data-button-type="outline"
        href={`/actions/refresh/?modal[type]=fetch`}
      >
        <span>
          Copy program from another {referAsClients ? "client" : "athlete"}
        </span>
      </a>
      <a
        role="button"
        data-button-type="primary"
        href={`/actions/refresh/?modal[type]=build-step-one&cycleType=new`}
      >
        <SvgIcon noFilterOnLight={true} src="/img/new-icons/add.svg" />
        Add new
      </a>
    </>
  );
};
